import React from "react";
import { Box, CssBaseline } from "@mui/material";
import PageAppBar from "./PageAppBar";
import PageTop from "./pagecontent/PageTop";
import ResponsiveScreenPageMidOne from "./pagecontent/ResponsiveScreenPageMidOne";
import PageMidTwo from "./pagecontent/PageMidTwo";
import FooterPage from "./pagecontent/FooterPage";
import Map from "./pagecontent/Map";

import {Route, Routes} from 'react-router-dom';
import ResponsiveComponent from "./appbar/ResponsiveComponent";
import ScrollToTopButton from "./pagecontent/ScrollToTopButton";

function App() {
    
    return (
    <>
    <CssBaseline />
    
    <Box>
        <ResponsiveComponent />
        <PageTop />
        <ResponsiveScreenPageMidOne />
        <PageMidTwo />
        <FooterPage />
        <ScrollToTopButton />
        

        <Routes>
            <Route path="/" exact component={<PageAppBar />} />
            <Route path="/map" exact component={<Map />} />
        </Routes>
    </Box>
    </>
    );
};
export default App;